"use client";

import ReactModal from "react-modal";
const Modal = ReactModal as any;
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import { handleFormatInputInt } from "@/helper";
import { FormInput, FormLabel } from "@/components/Base/Form";

interface ReturnModalProps {
	loading?: boolean;
	isOpen: boolean;
	onRequestClose: () => void;
	onConfirm: () => void;
	messageH: string;
	message: string;
	setQuantity: Dispatch<SetStateAction<string>>;
	quantity: string;
}

export default function ReturnModal({
	loading,
	isOpen,
	onRequestClose,
	onConfirm,
	setQuantity,
	quantity
}: ReturnModalProps) {
	const { t } = useTranslation();

	return (
		<Modal
			isOpen={isOpen}
			style={isOpen ? customStyles : closingStyles}
			contentLabel="Confirm Dialog"
			closeTimeoutMS={300}
			ariaHideApp={false}
		>
			<div>
				<div className="p-4">
					<h1 className="font-bold text-base">Return Item</h1>
					<div className="my-3 input-form ">
						<FormLabel htmlFor="price" className="flex flex-col w-full sm:flex-row">
							{t("quantity")}
							<span className="text-red-500 ml-1"> * </span>
						</FormLabel>
						<FormInput
							value={quantity}
							type="text"
							name="price"
							onInput={handleFormatInputInt}
							placeholder={t("enterQuantity")}
							onChange={(e) => {
								const value = e.target.value;
								setQuantity(value);
							}}
						/>
					</div>
				</div>

				<div className="flex justify-end gap-x-3 bg-[#F6F6F6] p-4">
					<button
						onClick={onRequestClose}
						disabled={loading}
						className="rounded-lg border-[1px] py-2.5 px-4 border-[#B9B9B9] bg-white text-optional text-[#383838] hover:bg-[#B9B9B9] transition flex items-center"
					>
						{t("cancel")}
					</button>

					<button
						onClick={onConfirm}
						disabled={loading}
						className={`rounded-lg py-1 px-4 text-white flex items-center justify-center gap-1 text-optional transition ${loading
							? "bg-primary cursor-not-allowed"
							: "bg-primary hover:bg-primary"
							}`}
					>
						{loading ? (
							<>
								<AiOutlineLoading3Quarters
									size={14}
									className="animate-spin"
								/>
								{t("confirm")}
							</>
						) : (
							t("confirm")
						)}
					</button>
				</div>
			</div>
		</Modal>
	);
}

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		transition: "opacity 300ms ease-in-out",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 999999,
	},
	content: {
		top: "20%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		transform: "translate(-50%, -50%)",
		transition: "transform 300ms ease-in-out, opacity 300ms ease-in-out",
		padding: "",
		borderRadius: "12px",
		border: "none",
		width: "95%",
		maxWidth: "640px",
		backgroundColor: "white",
	},
};

const closingStyles = {
	overlay: {
		...customStyles.overlay,
		opacity: 0,
	},
	content: {
		...customStyles.content,
		opacity: 0,
		transform: "translate(-50%, -40%)",
	},
};
